export const childAppURLToAppKeyMapping: {[label: string]: string} = {
	'mtime': 'mKRONOS',
	'mwlm': 'mWLM',

	'parent': 'portal',
}
